export default __webpack_public_path__ + "static/media/admin_product_bell_icon.db753ba8.svg";